import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Card, CardWithTitle } from "../../card/src";
import { Modal } from "../../dialog/src";
import { __, s__ } from "../../i18n/src";
import { FakeLink } from "../../link/src";
import { OrderSummary } from './OrderSummary';
export const OrderSummaryCard = (_a) => {
    var { cardProps, isCompact, title = s__('ShoppingCard|Order summary') } = _a, props = __rest(_a, ["cardProps", "isCompact", "title"]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    if (isCompact) {
        return (_jsxs(_Fragment, { children: [_jsxs(Card, Object.assign({ dataTestId: "order-summary-card" }, cardProps, { children: [_jsx(OrderSummary, Object.assign({}, props, { isCompact: true })), _jsx(FakeLink, { mt: 4, onClick: () => setIsModalOpen(true), children: __('View details') })] })), _jsx(Modal, { dataTestId: "order-summary-modal", header: title, isOpen: isModalOpen, onDismiss: () => setIsModalOpen(false), width: "small", children: _jsx(OrderSummary, Object.assign({}, props)) })] }));
    }
    return (_jsx(CardWithTitle, Object.assign({ dataTestId: "order-summary-card", title: title }, cardProps, { children: _jsx(OrderSummary, Object.assign({}, props)) })));
};
//# sourceMappingURL=OrderSummaryCard.js.map